import {
  AuthenticationDetails,
  CognitoRefreshToken,
  CognitoUser,
} from "amazon-cognito-identity-js";
import userpool from "../userpool";

export const authenticate = (Email, Password) => {
  return new Promise((resolve, reject) => {
    const user = new CognitoUser({
      Username: Email,
      Pool: userpool,
    });

    const authDetails = new AuthenticationDetails({
      Username: Email,
      Password: Password,
    });

    user.authenticateUser(authDetails, {
      onSuccess: (result) => {
        const idToken = result.getIdToken().getJwtToken();
        const refreshToken = result.getRefreshToken().getToken();
        storeTokenInSession(idToken, refreshToken);
        resolve(result);
      },
      onFailure: (err) => {
        reject(err);
      },
    });
  });
};

export const refreshIdToken = (refreshToken) => {
  return new Promise((resolve, reject) => {
    const user = userpool.getCurrentUser();
    if (!user || !refreshToken) {
      console.error(
        "No user or refresh token available for refreshing ID token."
      );
      reject(new Error("No refresh token available"));
      return;
    }

    try {
      const refreshTokenObj = new CognitoRefreshToken({
        RefreshToken: refreshToken,
      });

      user.refreshSession(refreshTokenObj, (err, session) => {
        if (err) {
          console.error("Error refreshing session:", err.message || err);
          reject(err);
        } else {
          const newIdToken = session.getIdToken().getJwtToken();
          const newRefreshToken = session.getRefreshToken().getToken();
          storeTokenInSession(newIdToken, newRefreshToken);
          resolve(newIdToken);
        }
      });
    } catch (error) {
      console.error(
        "Unexpected error during token refresh:",
        error.message || error
      );
      reject(error);
    }
  });
};

export const logout = () => {
  const user = userpool.getCurrentUser();
  sessionStorage.removeItem("pratham");
  localStorage.removeItem("prathamrefreshToken");
  if (!user) {
    console.error("No user is currently logged in.");
    window.location.href = "/";
    return;
  }
  user.signOut();

  window.location.href = "/";
};

// Function to store token in user session
const storeTokenInSession = (accessToken, refreshToken) => {
  sessionStorage.setItem("pratham", accessToken);
  localStorage.setItem("prathamrefreshToken", refreshToken);
};

// Function to get token from user session
export const getTokenFromSession = () => {
  return sessionStorage.getItem("pratham");
};

export const getRefreshToken = () => {
  return localStorage.getItem("prathamrefreshToken");
};
